// extracted by mini-css-extract-plugin
export default {"ValueTemplateContainer":"SelectOrType_ValueTemplateContainer__fM7gJ","DropdownContainer":"SelectOrType_DropdownContainer__lr-Fl"};